const CX=200,CY=200;
const CLIP_R_PREVIEW=143,CLIP_R_EXPORT=145,BAND_CHORD_R=151;
const R_TOP=151,R_BOT=182;
const BASE_INIT=210;
const BAND_TOP=182,BAND_BOT=218,BAND_LSW=4;
const LN_BASELINE=218;
const SP_STEP=1,ARC_DEG=300,DEFAULT_INIT_PCT=125;

const ARC_FS_MAP={SourceSerif:47,Bitter:44,Anton:39};
/* Last name always uses fixed font size — never shrinks */
const LN_FS_MAP={SourceSerif:54,Bitter:53,Anton:43};
/* Per-font advance-width multiplier used for auto-spacing estimate.
   Anton caps are narrower relative to em than serif fonts, so a smaller
   multiplier means auto-reduce triggers later (more chars fit before spacing drops). */
const LN_ADV_MAP={SourceSerif:0.60,Bitter:0.60,Anton:0.50};

const SWIRL_D=`M336.922,244.943c-0.542-0.303-1.205-0.289-1.731,0.037c-3.086,1.913-6.322,3.739-9.452,5.505 c-2.049,1.156-4.094,2.31-6.113,3.494c-18.592,10.911-38.83,17.159-58.527,18.068c-7.177,0.331-13.37-0.038-18.923-1.132 c-20.646-4.068-42.638-18.436-53.482-34.942c-9.967-15.169-10.067-40.422-0.223-56.294c7.503-12.095,18.631-19.032,34.021-21.209 c14.828-2.102,29.781,5.358,37.181,18.55c3.745,6.679,5.262,14.424,4.268,21.808c-0.709,5.263-3.516,9.968-7.904,13.246 c-4.936,3.688-11.319,5.253-17.504,4.296c-5.144-0.796-11.891-3.851-14.552-8.674c-1.667-3.022-2.651-8.013-1.413-11.136 c0.556-1.405,1.496-2.304,2.871-2.747c1.643-0.526,2.64,0.299,4.409,1.93c1.541,1.421,3.288,3.031,5.895,3.098 c5.664,0.18,9.544-2.734,10.391-7.706c0.923-5.413-2.249-12.598-8.981-14.769c-8.264-2.658-16.415-0.793-23.585,5.392 c-6.007,5.184-8.708,12.975-7.603,21.938c1.305,10.583,7.869,20.559,16.336,24.824c13.847,6.973,30.437,6.02,42.259-2.434 c16.711-11.946,21.636-36.971,11.212-56.972c-6.986-13.406-19.73-22.816-34.962-25.818c-16.57-3.266-34.334,1.312-49.352,12.59 c0.383-1.977,0.814-3.549,1.212-5.002c0.476-1.738,0.887-3.239,1.09-4.969c1.725-14.645,1.862-33.487-12.506-49.32 c-6.773-7.464-17.497-11.814-27.299-11.06c-5.076,0.385-9.975,1.8-14.168,4.091c-6.696,3.659-11.601,10.279-13.458,18.164 c-1.816,7.712-0.432,15.619,3.797,21.695c4.4,6.318,15.652,9.826,24.086,7.505c7.617-2.097,13.569-11.315,12.017-18.611 c-0.999-4.692-4.108-7.707-8.318-8.065c-2.156-0.183-3.946,0.326-5.334,1.511c-1.628,1.389-2.564,3.594-2.781,6.553l-0.05,0.735 c-0.247,3.747-0.558,4.973-3.298,5.148c-3.217,0.223-4.604-1.773-6.172-5.742c-2.723-6.897,2.237-14.196,8.395-17.005 c6.025-2.745,13.517-1.66,19.55,2.834c16.941,12.621,10.556,40.702,6.332,59.285l-0.477,2.102 c-1.748,7.745-3.262,14.238-4.967,20.752c-3.163,12.09-3.969,23.051-2.413,32.68c-0.531-0.423-1.097-0.863-1.692-1.322 c-0.874-0.675-1.701-1.312-2.1-1.69c-9.625-9.112-18.836-16.119-28.158-21.421c-5.458-3.103-11.182-5.705-17.014-7.735 c-11.912-4.147-24.596-4.243-36.677-0.276c-5.759,1.891-11.457,4.715-16.935,8.395c-14.662,9.845-22.678,27.246-21.443,46.549 c1.318,20.612,12.73,38.712,29.782,47.236c8.008,4.003,16.087,5.984,23.895,5.984c11.348-0.001,22.117-4.187,31.234-12.433 c13.773-12.46,16.937-32.681,7.522-48.082c-5.227-8.548-15.111-13.915-25.797-14.005c-0.094-0.001-0.188-0.001-0.282-0.001 c-10.323,0-20.094,4.748-24.951,12.147c-4.024,6.129-4.42,13.61-1.116,21.063c1.095,2.469,3.325,4.254,6.281,5.027 c3.802,0.992,8.323,0.195,11.246-1.988c4.596-3.435,3.935-7.459,3.35-11.009c-0.286-1.736-0.556-3.377-0.277-4.989 c0.415-2.391,1.667-3.729,3.827-4.093c4.651-0.776,11.589,3.108,13.572,6.694c5.948,10.75,3.925,20.806-5.55,27.59 c-11.53,8.254-31.844,9.228-42.561-2.57c-9.605-10.577-13.837-25.239-11.323-39.22c2.37-13.175,11.233-22.843,24.317-26.528 c16.549-4.656,32.803-0.8,51.163,12.142c13.516,9.527,25.497,21.246,37.083,32.578c3.963,3.876,8.06,7.883,12.165,11.752 c20.565,19.378,44.482,29.559,71.087,30.26c16.433,0.435,31.977-4.876,47.324-11.919c6.509-2.987,23.61-13.606,31.755-25.316 c0.306-0.441,0.747-0.771,0.79-1.306c0.338-4.309,0.521,1.305,0.574-4.242C337.794,245.822,337.461,245.248,336.922,244.943z`;

/* 2 swirls: [a, d, e, f] for matrix(a,0,0,d,e,f) */
const SWIRL_MATRICES=[
  [ 0.35,  0.35,  43, 80],
  [-0.35, -0.35, 357,320],
];

const FONT_URLS={
  SourceSerif:['https://cdn.jsdelivr.net/npm/@fontsource/source-serif-4@5/files/source-serif-4-latin-700-normal.woff','https://cdn.jsdelivr.net/npm/@fontsource/source-serif-4@4/files/source-serif-4-latin-700-normal.woff','https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/sourceserif4/static/SourceSerif4-Bold.ttf'],
  Bitter:['https://cdn.jsdelivr.net/npm/@fontsource/bitter@5/files/bitter-latin-700-normal.woff','https://cdn.jsdelivr.net/npm/@fontsource/bitter@4/files/bitter-latin-700-normal.woff','https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/bitter/static/Bitter-Bold.ttf'],
  Anton:['https://cdn.jsdelivr.net/npm/@fontsource/anton@5/files/anton-latin-400-normal.woff','https://cdn.jsdelivr.net/npm/@fontsource/anton@4/files/anton-latin-400-normal.woff','https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/anton/Anton-Regular.ttf'],
};
const FONT_CSS={SourceSerif:"'Source Serif 4',Georgia,serif",Bitter:"'Bitter',Georgia,serif",Anton:"'Anton',Impact,sans-serif"};
const FONT_WEIGHT={SourceSerif:'700',Bitter:'700',Anton:'400'};

function loadScript(u){return new Promise((res,rej)=>{const s=document.createElement('script');s.src=u;s.onload=res;s.onerror=()=>rej();document.head.appendChild(s);});}
async function requireLib(g,urls){if(window[g])return true;for(const u of urls){try{await loadScript(u);if(window[g])return true;}catch(_){}}return false;}
const OT_CDNS=['https://cdn.jsdelivr.net/npm/opentype.js@1.3.4/dist/opentype.min.js','https://cdnjs.cloudflare.com/ajax/libs/opentype.js/1.3.4/opentype.min.js','https://unpkg.com/opentype.js@1.3.4/dist/opentype.min.js'];
const PP_CDNS=['https://cdnjs.cloudflare.com/ajax/libs/paper.js/0.12.17/paper-full.min.js','https://cdn.jsdelivr.net/npm/paper@0.12.17/dist/paper-full.min.js','https://unpkg.com/paper@0.12.17/dist/paper-full.min.js'];

const CV='mgb_';
function b2s(buf){const b=new Uint8Array(buf);let s='';for(let i=0;i<b.byteLength;i++)s+=String.fromCharCode(b[i]);return btoa(s);}
function s2b(s){const d=atob(s),b=new Uint8Array(d.length);for(let i=0;i<d.length;i++)b[i]=d.charCodeAt(i);return b.buffer;}
function saveCache(k,buf){try{localStorage.setItem(CV+k,b2s(buf));}catch(_){}}
function loadCache(k){try{const s=localStorage.getItem(CV+k);return s?s2b(s):null;}catch(_){return null;}}
const fontCache={};

async function fetchFontBuffer(key){
  const c=loadCache(key);if(c)return c;
  for(const url of(FONT_URLS[key]||[])){
    try{const r=await fetch(url,{mode:'cors'});if(r.ok){const buf=await r.arrayBuffer();saveCache(key,buf);return buf;}}catch(_){}
    if(window.opentype){const f=await new Promise(res=>window.opentype.load(url,(e,f)=>res(e?null:f)));if(f){fontCache[key]=f;return null;}}
  }
  return null;
}
async function loadFont(key){
  if(fontCache[key])return true;if(!window.opentype)return false;
  const buf=await fetchFontBuffer(key);if(fontCache[key])return true;if(!buf)return false;
  try{fontCache[key]=window.opentype.parse(buf);return true;}catch(_){return false;}
}
function setStatus(c,m){document.getElementById('fsDot').className='fs-dot '+c;document.getElementById('fsText').textContent=m;}
async function initFonts(){
  setStatus('loading','Loading fonts...');
  const otOk=await requireLib('opentype',OT_CDNS);
  const ppOk=await requireLib('paper',PP_CDNS);
  if(!otOk){setStatus('error','opentype.js unavailable');return;}
  if(!ppOk){setStatus('error','paper.js unavailable');return;}
  const keys=['SourceSerif','Bitter','Anton'];
  const res=await Promise.all(keys.map(k=>loadFont(k)));
  const fail=keys.filter((_,i)=>!res[i]);
  setStatus(fail.length?'error':'ready',fail.length?'Needs internet once ('+fail.join(', ')+' failed)':'Fonts ready');
  render();
}
document.getElementById('fsClear').addEventListener('click',()=>{
  ['SourceSerif','Bitter','Anton'].forEach(k=>{try{localStorage.removeItem(CV+k);}catch(_){}delete fontCache[k];});
  setStatus('loading','Reloading...');initFonts();
});

const state={fontVal:'SourceSerif',initFont:'SourceSerif',sizeVal:305,initialSize:DEFAULT_INIT_PCT,flourish:'scroll',topSpUser:2,botSpUser:4,lnSpUser:2};

function getInitialBaseline(fontKey,ch,fontSize){
  const font=fontCache[fontKey];
  if(font){try{const sc=fontSize/font.unitsPerEm;const bb=font.charToGlyph(ch).getBoundingBox();return CY+(bb.y2+bb.y1)*sc/2;}catch(_){}}
  return CY+fontSize*0.72/2;
}

function adaptiveSpacing(text,R,userSp,arcFs){
  if(!text||text.length<=1)return userSp;
  const usableArcLen=(ARC_DEG-30)*Math.PI/180*R;
  const charW=text.length*arcFs*0.62;
  const gaps=text.length-1;if(!gaps)return userSp;
  return Math.max(-6,Math.min(userSp,(usableArcLen-charW)/gaps));
}

function chordHalf(y,r){return Math.sqrt(Math.max(0,r*r-(y-CY)*(y-CY)));}

/* Last name: FIXED font size, VARIABLE letter-spacing.
   userSp = user's preferred max spacing.
   Auto-reduces below userSp when name is too long to fit at that spacing.
   Per-font advance multiplier controls when auto-reduce triggers. */
function lastNameLetterSpacing(name,fontSize,fontKey,userSp){
  if(!name||name.length<=1)return userSp;
  const avail=2*chordHalf((BAND_TOP+BAND_BOT)/2,CLIP_R_PREVIEW)*0.86;
  const adv=LN_ADV_MAP[fontKey]||0.60;
  const charW=name.length*fontSize*adv;
  const gaps=name.length-1;
  const autoSp=(avail-charW)/gaps;
  return Math.max(-8,Math.min(userSp,autoSp));
}

function render(){
  const topTxt=(document.getElementById('topText').value.trim()||'SOFIA & THOMAS').toUpperCase();
  const lastNm=(document.getElementById('lastName').value.trim()||'SLATERS').toUpperCase();
  const init=(document.getElementById('initial').value.trim()||'S').toUpperCase().charAt(0);
  const botTxt=(document.getElementById('botText').value.trim()||'EST. 2026').toUpperCase();
  const arcCSS=FONT_CSS[state.fontVal],initCSS=FONT_CSS[state.initFont];
  const iSize=Math.round(BASE_INIT*state.initialSize/100);
  const arcFs=ARC_FS_MAP[state.fontVal];
  const lnFs=LN_FS_MAP[state.fontVal];  /* always fixed */
  const topSp=adaptiveSpacing(topTxt,R_TOP,state.topSpUser,arcFs);
  const botSp=adaptiveSpacing(botTxt,R_BOT,state.botSpUser,arcFs);
  const lnSp=lastNameLetterSpacing(lastNm,lnFs,state.fontVal,state.lnSpUser);

  document.getElementById('topSpAuto').textContent=topSp<state.topSpUser?'(auto: '+topSp.toFixed(0)+'px)':'';
  document.getElementById('botSpAuto').textContent=botSp<state.botSpUser?'(auto: '+botSp.toFixed(0)+'px)':'';

  ['svgTopText','svgBotText','svgLastName'].forEach(id=>{
    const el=document.getElementById(id);if(!el)return;
    el.setAttribute('font-family',arcCSS);el.setAttribute('font-weight',FONT_WEIGHT[state.fontVal]);
  });

  const topEl=document.getElementById('svgTopText');
  topEl.querySelector('textPath').textContent=topTxt;
  topEl.setAttribute('font-size',arcFs);topEl.setAttribute('letter-spacing',topSp.toFixed(1));

  const botEl=document.getElementById('svgBotText');
  botEl.querySelector('textPath').textContent=botTxt;
  botEl.setAttribute('font-size',arcFs);botEl.setAttribute('letter-spacing',botSp.toFixed(1));

  const baseline=getInitialBaseline(state.initFont,init,iSize);
  const initEl=document.getElementById('svgInitial');
  initEl.textContent=init;initEl.setAttribute('font-size',iSize);
  initEl.setAttribute('font-family',initCSS);initEl.setAttribute('font-weight',FONT_WEIGHT[state.initFont]);
  initEl.setAttribute('y',baseline.toFixed(1));

  document.getElementById('svgBandFill').setAttribute('y',BAND_TOP);
  document.getElementById('svgBandFill').setAttribute('height',BAND_BOT-BAND_TOP);

  const tH=chordHalf(BAND_TOP,BAND_CHORD_R),bH=chordHalf(BAND_BOT,BAND_CHORD_R);
  const bTop=document.getElementById('svgBandTop');
  bTop.setAttribute('x1',(CX-tH).toFixed(1));bTop.setAttribute('x2',(CX+tH).toFixed(1));
  bTop.setAttribute('y1',BAND_TOP);bTop.setAttribute('y2',BAND_TOP);
  const bBot=document.getElementById('svgBandBot');
  bBot.setAttribute('x1',(CX-bH).toFixed(1));bBot.setAttribute('x2',(CX+bH).toFixed(1));
  bBot.setAttribute('y1',BAND_BOT);bBot.setAttribute('y2',BAND_BOT);

  /* Last name: fixed size, computed spacing */
  const lnEl=document.getElementById('svgLastName');
  lnEl.textContent=lastNm;
  lnEl.setAttribute('font-size',lnFs);
  lnEl.setAttribute('letter-spacing',lnSp.toFixed(1));
  lnEl.setAttribute('font-family',arcCSS);lnEl.setAttribute('font-weight',FONT_WEIGHT[state.fontVal]);
  lnEl.setAttribute('y',LN_BASELINE.toFixed(1));

  document.getElementById('svgFlourish').style.display=state.flourish==='none'?'none':'';
}

/* PATH HELPERS */
function extractD(s){return((s.match(/d="([^"]+)"/))||[])[1]||'';}
function circlePath(cx,cy,r){return 'M'+(cx-r)+','+cy+' A'+r+','+r+' 0 1,0 '+(cx+r)+','+cy+' A'+r+','+r+' 0 1,0 '+(cx-r)+','+cy+'Z';}
function annularPath(cx,cy,r,sw){return circlePath(cx,cy,r+sw/2)+' '+circlePath(cx,cy,r-sw/2);}
function lineRectPath(x1,y,x2,sw){const h=sw/2;return 'M'+x1+','+(y-h)+' L'+x2+','+(y-h)+' L'+x2+','+(y+h)+' L'+x1+','+(y+h)+'Z';}

function centeredTextPaths(font,text,cx,baseline,fontSize,lsP){
  if(!font||!text)return[];
  const sc=fontSize/font.unitsPerEm;
  let w=0;for(const c of text)w+=(font.charToGlyph(c).advanceWidth||0)*sc;
  w+=Math.max(0,text.length-1)*lsP;
  let x=cx-w/2;const ds=[];
  for(let i=0;i<text.length;i++){
    const g=font.charToGlyph(text[i]);const adv=(g.advanceWidth||0)*sc;
    const d=extractD(g.getPath(x,baseline,fontSize).toSVG(2));
    if(d)ds.push(d);x+=adv+(i<text.length-1?lsP:0);
  }
  return ds;
}

function arcTextPaths(font,text,cx,cy,R,fontSize,lsP,isTop){
  if(!font||!text)return[];
  const sc=fontSize/font.unitsPerEm;
  let tw=0;const chars=[];
  for(const c of text){const g=font.charToGlyph(c);const adv=(g.advanceWidth||0)*sc;chars.push({g,adv});tw+=adv;}
  tw+=Math.max(0,text.length-1)*lsP;
  const halfAng=tw/(2*R);const am=isTop?3*Math.PI/2:Math.PI/2;
  let alpha=isTop?am-halfAng:am+halfAng;const step=isTop?1:-1;const out=[];
  for(let i=0;i<chars.length;i++){
    const{g,adv}=chars[i];const ca=alpha+step*(adv/2)/R;
    const px=cx+R*Math.cos(ca),py=cy+R*Math.sin(ca);
    const rot=isTop?Math.atan2(Math.cos(ca),-Math.sin(ca))*180/Math.PI:Math.atan2(-Math.cos(ca),Math.sin(ca))*180/Math.PI;
    const d=extractD(g.getPath(-adv/2,0,fontSize).toSVG(2));
    if(d)out.push({d,transform:'translate('+px.toFixed(3)+','+py.toFixed(3)+') rotate('+rot.toFixed(3)+')'});
    alpha+=step*(adv+(i<chars.length-1?lsP:0))/R;
  }
  return out;
}

/* Last name for export — uses real opentype advance widths, respects user spacing max */
function lastNameLetterSpacingOT(font,name,fontSize,userSp){
  if(!font||!name||name.length<=1)return userSp;
  const sc=fontSize/font.unitsPerEm;
  let charW=0;
  for(const c of name)charW+=(font.charToGlyph(c).advanceWidth||0)*sc;
  const avail=2*chordHalf((BAND_TOP+BAND_BOT)/2,CLIP_R_EXPORT)*0.86;
  const gaps=name.length-1;if(!gaps)return userSp;
  const autoSp=(avail-charW)/gaps;
  return Math.max(-8,Math.min(userSp,autoSp));
}

function importItem(d,t){
  const a=t?' transform="'+t+'"':'';
  const root=paper.project.importSVG('<svg xmlns="http://www.w3.org/2000/svg"><path d="'+d.replace(/"/g,"'")+'"'+a+'/></svg>',{insert:false});
  return root.firstChild;
}
function importEO(d){
  const root=paper.project.importSVG('<svg xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="'+d.replace(/"/g,"'")+'" /></svg>',{insert:false});
  return root.firstChild;
}
function importMatrix(d,a,dd,e,f){
  const t='matrix('+a+',0,0,'+dd+','+e+','+f+')';
  const root=paper.project.importSVG('<svg xmlns="http://www.w3.org/2000/svg"><path transform="'+t+'" d="'+d.replace(/"/g,"'")+'" /></svg>',{insert:false});
  return root.firstChild;
}
function safeUnite(a,b){
  try{const r=a.unite(b);if(r){a.remove();b.remove();return r;}}catch(_){}
  try{b.remove();}catch(_){}return a;
}

async function downloadWelded(){
  const btn=document.getElementById('dlBtn');
  const overlay=document.getElementById('loadOverlay');
  const title=document.getElementById('loadTitle');
  const sub=document.getElementById('loadSub');
  btn.disabled=true;overlay.classList.add('visible');
  const tick=()=>new Promise(r=>setTimeout(r,14));
  try{
    title.textContent='Converting to paths...';
    sub.textContent='Checking libraries...';await tick();
    const otOk=await requireLib('opentype',OT_CDNS);
    const ppOk=await requireLib('paper',PP_CDNS);
    if(!otOk)throw new Error('opentype.js could not be loaded.\nCheck internet connection.');
    if(!ppOk)throw new Error('paper.js could not be loaded.\nCheck internet connection.');

    const arcKey=state.fontVal,initKey=state.initFont;
    for(const k of[...new Set([arcKey,initKey])]){
      if(!fontCache[k]){sub.textContent='Loading font: '+k+'...';await tick();if(!await loadFont(k))throw new Error('Font "'+k+'" failed.');}
    }

    const arcFont=fontCache[arcKey],initFont=fontCache[initKey];
    const topTxt=(document.getElementById('topText').value.trim()||'SOFIA & THOMAS').toUpperCase();
    const lastNm=(document.getElementById('lastName').value.trim()||'SLATERS').toUpperCase();
    const init=(document.getElementById('initial').value.trim()||'S').toUpperCase().charAt(0);
    const botTxt=(document.getElementById('botText').value.trim()||'EST. 2026').toUpperCase();
    const iSize=Math.round(BASE_INIT*state.initialSize/100);
    const arcFs=ARC_FS_MAP[arcKey];
    const lnFs=LN_FS_MAP[arcKey];
    const tH=chordHalf(BAND_TOP,BAND_CHORD_R),bH=chordHalf(BAND_BOT,BAND_CHORD_R);
    const topSp=adaptiveSpacing(topTxt,R_TOP,state.topSpUser,arcFs);
    const botSp=adaptiveSpacing(botTxt,R_BOT,state.botSpUser,arcFs);
    const lnSp=lastNameLetterSpacingOT(arcFont,lastNm,lnFs,state.lnSpUser);

    let initBL;
    try{const sc=iSize/initFont.unitsPerEm;const bb=initFont.charToGlyph(init).getBoundingBox();initBL=CY+(bb.y2+bb.y1)*sc/2;}
    catch(_){initBL=CY+iSize*0.72/2;}

    sub.textContent='Building glyph paths...';await tick();
    const initDs=centeredTextPaths(initFont,init,CX,initBL,iSize,0);
    const lnDs=centeredTextPaths(arcFont,lastNm,CX,LN_BASELINE,lnFs,lnSp);
    const topArcs=arcTextPaths(arcFont,topTxt,CX,CY,R_TOP,arcFs,topSp,true);
    const botArcs=arcTextPaths(arcFont,botTxt,CX,CY,R_BOT,arcFs,botSp,false);

    sub.textContent='Setting up boolean engine...';await tick();
    paper.setup(document.getElementById('paperCanvas'));
    paper.project.clear();
    const C=new paper.Point(CX,CY);

    sub.textContent='Processing rings...';await tick();
    const ring1=importEO(annularPath(CX,CY,186,9));
    const ring2=importEO(annularPath(CX,CY,148,9));

    sub.textContent='Processing initial...';await tick();
    let initItem=null;
    for(const d of initDs){const p=importItem(d,null);initItem=initItem?safeUnite(initItem,p):p;}
    let initFinal=null;
    if(initItem){
      const clipC=new paper.Path.Circle(C,CLIP_R_EXPORT);
      const clipped=initItem.intersect(clipC);clipC.remove();initItem.remove();
      const bandRect=new paper.Path.Rectangle(new paper.Point(0,BAND_TOP),new paper.Point(400,BAND_BOT));
      initFinal=clipped.subtract(bandRect);clipped.remove();bandRect.remove();
    }

    sub.textContent='Processing band...';await tick();
    const bTopR=importItem(lineRectPath(CX-tH,BAND_TOP,CX+tH,BAND_LSW),null);
    const bBotR=importItem(lineRectPath(CX-bH,BAND_BOT,CX+bH,BAND_LSW),null);

    sub.textContent='Processing last name...';await tick();
    let lnItem=null;
    for(const d of lnDs){const p=importItem(d,null);lnItem=lnItem?safeUnite(lnItem,p):p;}

    sub.textContent='Processing top arc...';await tick();
    let topItem=null;
    for(const{d,transform}of topArcs){const p=importItem(d,transform);topItem=topItem?safeUnite(topItem,p):p;}

    sub.textContent='Processing bottom arc...';await tick();
    let botItem=null;
    for(const{d,transform}of botArcs){const p=importItem(d,transform);botItem=botItem?safeUnite(botItem,p):p;}

    let swirlItem=null;
    if(state.flourish==='scroll'){
      sub.textContent='Processing swirls...';await tick();
      for(const[a,dd,e,f]of SWIRL_MATRICES){
        const p=importMatrix(SWIRL_D,a,dd,e,f);
        swirlItem=swirlItem?safeUnite(swirlItem,p):p;
      }
    }

    const items=[ring1,ring2,initFinal,bTopR,bBotR,lnItem,topItem,botItem,swirlItem].filter(Boolean);
    let united=items[0];
    for(let i=1;i<items.length;i++){sub.textContent='Welding '+i+' of '+(items.length-1)+'...';await tick();united=safeUnite(united,items[i]);}

    sub.textContent='Exporting SVG...';await tick();
    const mm=parseInt(state.sizeVal);
    const svg='<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400" width="'+mm+'mm" height="'+mm+'mm">\n  <path fill="#000000" fill-rule="evenodd" d="'+united.pathData+'"/>\n</svg>';
    paper.project.clear();

    const blob=new Blob([svg],{type:'image/svg+xml'});
    const url=URL.createObjectURL(blob);
    Object.assign(document.createElement('a'),{href:url,download:'monogram-sign.svg'}).click();
    URL.revokeObjectURL(url);
  }catch(err){console.error(err);alert('Export error:\n\n'+(err.message||String(err)));}
  finally{btn.disabled=false;overlay.classList.remove('visible');}
}

/* UI WIRING */
function initSeg(gid,key){
  document.getElementById(gid).querySelectorAll('.sb').forEach(b=>{
    b.addEventListener('click',()=>{document.getElementById(gid).querySelectorAll('.sb').forEach(x=>x.classList.remove('on'));b.classList.add('on');state[key]=b.dataset.val;render();});
  });
}
initSeg('sizeGroup','sizeVal');initSeg('fontGroup','fontVal');initSeg('flourishGroup','flourish');

document.getElementById('initFontGroup').querySelectorAll('.sb').forEach(b=>{
  b.addEventListener('click',()=>{
    document.getElementById('initFontGroup').querySelectorAll('.sb').forEach(x=>x.classList.remove('on'));
    b.classList.add('on');state.initFont=b.dataset.val;
    const inp=document.getElementById('initial');
    inp.style.fontFamily=FONT_CSS[b.dataset.val];inp.style.fontWeight=FONT_WEIGHT[b.dataset.val];
    render();
  });
});

['topText','botText','lastName'].forEach(id=>document.getElementById(id).addEventListener('input',render));
document.getElementById('initial').addEventListener('input',function(){this.value=this.value.toUpperCase().slice(0,1);render();});
document.getElementById('lastName').addEventListener('input',function(){
  const f=document.getElementById('initial');if(!f.value&&this.value)f.value=this.value[0].toUpperCase();render();
});
document.getElementById('initDec').addEventListener('click',()=>{state.initialSize=Math.max(50,state.initialSize-5);document.getElementById('initialSizeVal').textContent=state.initialSize+'%';render();});
document.getElementById('initInc').addEventListener('click',()=>{state.initialSize=Math.min(200,state.initialSize+5);document.getElementById('initialSizeVal').textContent=state.initialSize+'%';render();});

function makeSpStepper(iId,dId,vId,key){
  const el=document.getElementById(vId);
  document.getElementById(iId).addEventListener('click',()=>{state[key]=Math.min(80,state[key]+SP_STEP);el.textContent=state[key]+' px';render();});
  document.getElementById(dId).addEventListener('click',()=>{state[key]=Math.max(-10,state[key]-SP_STEP);el.textContent=state[key]+' px';render();});
}
makeSpStepper('topSpInc','topSpDec','topSpVal','topSpUser');
makeSpStepper('botSpInc','botSpDec','botSpVal','botSpUser');
makeSpStepper('lnSpInc','lnSpDec','lnSpVal','lnSpUser');
document.getElementById('dlBtn').addEventListener('click',downloadWelded);
render();
initFonts();